<template lang="pug">
  div.navigation-menu-wrapper
    ul.contextual-menu.is-menu(:class="{minimize: minimize}")
      li.info
        router-link(:to="{ name: 'action', params: { id: action[idAzione], fase: action[fase] }}" @click.native="open()" tooltip="Informazioni Generali")
          icon-base(width="30" height="30" icon-name="info")
            icon-info
      li.caratterizzazione
        router-link(:to="`/action/${action[idAzione]}/${action[fase]}/characterization`" @click.native="open()" tooltip="Caratterizzazione")
          icon-base(width="30" height="30" icon-name="info")
            icon-poi
      li.indicatori
        router-link(:to="`/action/${action[idAzione]}/${action[fase]}/indicators`" @click.native="open()" tooltip="Indicatori")
          icon-base(width="30" height="30" icon-name="info")
            icon-line-chart
    ul.minimize-menu.is-menu
      li(@click="minimizeAside")
        a.expand(v-if="minimize" tooltip="Espandi")
          icon-base(width="30" height="30" icon-name="minimize")
            icon-arrow-small
        a.minimize(v-else tooltip="Minimizza")
          icon-base(width="30" height="30" icon-name="minimize")
            icon-arrow-small
    ul.services-menu.is-menu
      li.faq
        a(href="static/guida.html" tooltip="Guida utente" target="new")
          icon-base(width="30" height="30" icon-name="guida utente")
            icon-question
      li.search
        router-link(to="/advanced-search" tooltip="Ricerca")
          icon-base(width="30" height="30" icon-name="Ricerca")
            icon-search
      li.home
        router-link(to="/" tooltip="Home")
          icon-base(width="30" height="30" icon-name="home")
            icon-home
</template>

<script>

import IconBase from '@/components/IconBase'
import IconPoi from '@/components/icons/IconPoi'
import IconLineChart from '@/components/icons/IconLineChart'
import IconInfo from '@/components/icons/IconInfo'
import IconSearch from '@/components/icons/IconSearch'
import IconQuestion from '@/components/icons/IconQuestion'
import IconHome from '@/components/icons/IconHome'
import IconArrowSmall from '@/components/icons/IconArrowSmall'
export default {
  name: 'TheNavigationAction',
  props: {
    action: {
      type: Object
    },
    idFase: {
      type: [String, Number]
    },
    minimize: {
      type: Boolean
    }
  },
  components: {
    IconBase,
    IconPoi,
    IconInfo,
    IconLineChart,
    IconSearch,
    IconQuestion,
    IconHome,
    IconArrowSmall
  },
  data () {
    return {
      fase: 'Azioni.fase',
      idAzione: 'Azioni.idAzione'
    }
  },
  mounted: function () {
    // 🤖 code
  },
  methods: {
    minimizeAside () {
      this.$store.commit('SET_MINIMIZE')
    },
    open () {
      // this.$store.commit('SET_MAXIMIZE')
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  color: #ffffff;
  padding: 15px;
  display: block;
  position: relative;
  width: 60px;
  &.router-link-exact-active,
  &:hover {
    background-color: $background;
    box-shadow: 0 3px 5px rgba(57, 63, 72, 0.3);
  }
  &::after {
    content: attr(tooltip);
    display: inline-block;
    position: absolute;
    z-index: 1;
    max-width: 60px;
    padding: 1em;
    top: 0;
    bottom: 0;
    font-size: 1.1rem;
    left: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1.3;
    background-color: $background;
    opacity: 0;
    transform: translate(0);
    transition: all .4s ease-in-out;
  }
}
.is-menu {
  a:not(.router-link-exact-active):hover,
  &.minimize a:hover {
    max-width: 20rem;
    transition: max-width .2s ease-in-out;
    &::after {
      max-width: 20rem;
      transform: translate(3.5rem, 0);
      opacity: 1;
    }
  }
}
.contextual-menu {
  a {
    border-bottom: 1px solid #ffffff;
    &.router-link-exact-active,
    &:hover {
      border-bottom: 1px solid transparent;
    }
  }
}
.services-menu {
  margin-top: 6em;
}
.minimize-menu {
  margin-top: 4em; // 🤖 TEMP
  cursor: pointer;
  font-size: 2em;
  .expand svg {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheNavigationAction.vue